// components/AccountTypeSelector.jsx
import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';


const AccountTypeSelector = ({ onNext }) => {
  const [selectedType, setSelectedType] = useState(null);

  const handleNext = () => {
    if (selectedType && onNext) {
      onNext(selectedType);
    }
  };

  const isSelected = (type) =>
    selectedType === type ? 'border border-4 border-warning shadow' : 'border border-light';

  const circleStyle = {
    width: '160px',
    height: '160px',
    borderRadius: '50%',
    backgroundColor: '#f9f9f9',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  };
  // Render loading spinner first

  return (


    <div
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center text-center px-3"
      style={{
        backgroundImage: 'url(/images/auth/register.jpg)',
        backgroundSize: 'cover',       // cover the full container
        backgroundPosition: 'center',   // center the image
        backgroundRepeat: 'no-repeat',  // prevent tiling
        width: '100%',
        height: '100%',
        minHeight: '100vh'              // ensure full viewport height
      }}
    >
      <HTopbar />


      <Container
        style={{
          maxWidth: '420px',
          padding: '30px',                     // inner spacing
          borderRadius: '12px',                // rounded corners
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)', // subtle shadow
          backgroundColor: '#FFFFFF'           // solid background, no transparency
        }}
      >
        <h1
          style={{
            fontSize: '60px',   // huge font
            fontWeight: 900,     // extra-bold / thick
            letterSpacing: '2px',
            color: '#201e1e',    // strong contrast on white
            lineHeight: 1.1,
            textAlign: 'center'
          }}
        >
          MATCH <span style={{ fontWeight: 700 }}>UP</span>
        </h1>
        <p className="mb-1">Start your sport journey with MatchUp</p>
        <p className="mt-4 mb-4 fw-bold">Select your Occupation</p>

        <Row className="justify-content-center g-3 mb-4">
          <Col xs="auto">
            <div
              className={`d-flex flex-column align-items-center justify-content-center ${isSelected('sport_participant')}`}
              style={circleStyle}
              onClick={() => setSelectedType('sport_participant')}
            >
              <img
                src="/images/participant.jpg"
                alt="Sport Participant"
                className="rounded-circle mb-2"
                style={{ width: '60px', height: '60px', objectFit: 'cover' }}
              />
              <div style={{ fontSize: '12px', fontWeight: 'bold' }}>SPORT PARTICIPANT</div>
            </div>
            <small className="text-muted d-block mt-1">e.g. athlete, enthusiast</small>
          </Col>

          <Col xs="auto">
            <div
              className={`d-flex flex-column align-items-center justify-content-center ${isSelected('sport_organizer')}`}
              style={circleStyle}
              onClick={() => setSelectedType('sport_organizer')}
            >
              <img
                src="/images/organizer.jpg"
                alt="Organizer"
                className="rounded-circle mb-2"
                style={{ width: '60px', height: '60px', objectFit: 'cover' }}
              />
              <div style={{ fontSize: '12px', fontWeight: 'bold' }}>ORGANIZER</div>
            </div>
          </Col>
        </Row>

        <Button variant="dark" className="w-100" disabled={!selectedType} onClick={handleNext}>
          NEXT
        </Button>
      </Container>
    </div>
  );
};

export default AccountTypeSelector;
